<template>
  <li class="search-card">
    <div class="search-card__container">
        <z-link class="search-card__link" :href="searchItem.url">{{ searchItem.title }}</z-link>
        <vue-raw class="html-content search-card__text" :raw="searchItem.text">
        </vue-raw>
    </div>

    <div class="search-card__container" v-if="searchItem.date">
        <z-caption class="search-card__subtext" tag="p" size="xs">{{ text.dateText }}</z-caption>
        <z-caption class="search-card__subtext" tag="p" size="xs">{{ searchItem.date | momentFilter('DD MMMM YYYY') }}</z-caption>
    </div>
  </li>
</template>

<script>
import moment from 'moment'
import { localize } from '@/utils/i18n.js'

export default {
    name: 'search-card',
    props: {
        searchItem: {
            type: Object
        }
    },
    data () {
        return {
            date: this.searchItem.date,
            text: {
                dateText: localize({
                    ru: 'Изменен',
                    en: 'Changed'
                })
            }
        }
    },
    computed: {
        searchItemDate () {
            return moment.unix(this.date).format('DD/MM/YYYY')
        }
    }
}
</script>

<style lang="scss">
.search-card {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    flex: 2 1;
    padding: 40px $token-spacers-xs $token-spacers-xs $token-spacers-xs;
    border-bottom: 1px solid $token-colors-black-40;

    &:first-child {
        border-top: 2px solid $token-colors-secondary;
    }

    &__container {
        margin-bottom: $token-spacers-xs;

        &:first-child {
            flex-basis: 80%;
        }
    }

    &__link {
        font-size: 28px;
        margin-bottom: 12px;
        display: block !important;
        font-weight: 600;
    }

    &__subtext {
        color: $token-colors-black-30 !important;
        margin-bottom: 0 !important;
    }
}

</style>
